/** 0033612345678 ou +33612345678 -> 06 12 34 56 78 (les numéros étrangers restent tels quels). */
export function numeroLisible(numero) {
    const n = (numero || "").replace(/^\+33|^0033/, "0");
    return /^0\d{9}$/.test(n) ? n.replace(/(\d\d)(?=\d)/g, "$1 ") : (numero || "Numéro masqué");
}

/** Délai de rappel : 1800 -> « 30 min », 7500 -> « 2 h 05 », 180000 -> « 2 j 2 h ». */
export function delaiLisible(secondes) {
    if (secondes === null || secondes === undefined) {
        return "—";
    }
    const minutes = Math.round(secondes / 60);
    if (minutes < 60) {
        return minutes + " min";
    }
    const heures = Math.floor(minutes / 60);
    if (heures < 24) {
        return heures + " h " + String(minutes % 60).padStart(2, "0");
    }
    return Math.floor(heures / 24) + " j " + (heures % 24) + " h";
}

/**
 * Grille jours × heures des créneaux renvoyés par l'API ([{jour: 1-7, heure, recus, manques}]),
 * limitée aux heures où il y a eu des appels (8 h - 19 h au minimum).
 */
export function grilleCreneaux(creneaux) {
    const heuresAvecAppels = creneaux.map(c => c.heure);
    const debut = Math.min(8, ...heuresAvecAppels);
    const fin = Math.max(19, ...heuresAvecAppels);
    const heures = [];
    for (let h = debut; h <= fin; h++) {
        heures.push(h);
    }
    const cases = {};
    creneaux.forEach(c => {
        cases[c.jour + "-" + c.heure] = c;
    });
    const max = Math.max(1, ...creneaux.map(c => c.recus));

    return {
        heures,
        lignes: [1, 2, 3, 4, 5, 6, 7].map(jour => ({
            jour,
            cases: heures.map(heure => cases[jour + "-" + heure] || {jour, heure, recus: 0, manques: 0}),
        })),
        max,
    };
}

/** 75 -> « 1 min 15 s » */
export function dureeLisible(secondes) {
    if (!secondes) {
        return "—";
    }
    const minutes = Math.floor(secondes / 60);
    return (minutes ? minutes + " min " : "") + (secondes % 60) + " s";
}
